import React from 'react';
import { apiVariables } from '../utils/variables';

async function checkLevel(){
    return await fetch( apiVariables.apiLink + 'user/level', {
        method: 'get',
        credentials: apiVariables.credentials
    })
    .then((response) => response.statusText)
}

export class Profile extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            level: null
        }
    }
    async componentWillMount(){
        this.setState({level: await checkLevel()})
    }
    render(){
        return(
            <div>
                {this.state.level !== null ? 
                    <div>{this.viewSwitch(this.state.level)}</div>    
                : null}
            </div>
        );
    }
    viewSwitch(level){
        switch(level){
            case "admin":
                return(
                    <AdminPanel organizations={this.props.organizations}/>
                );
            case "user":
                return(
                    <UserPanel />
                );
            default:
                return(<h1>Something went wrong</h1>)
        }
    }
    
    
}
class UserPanel extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            message: null
        }
        this.tryChange = this.tryChange.bind(this)
    }
    render(){
        return (
            <div className="main-div">
                <div className="col-md-4"></div>
                <div className="col-md-4">
                    <div className="panel" style={{marginTop: 50}}>
                        <h2>Change password</h2>
                    </div>
                    <form id="ChangePassword" style={{marginBottom: 20}}>
                        <div className="form-group" style={{marginBottom: 20, paddingBottom: 30, borderBottom: "2px solid #E7E7E7"}}>
                            <input type="password" className="form-control" id="inputName" placeholder="Current Password" ref={(input)=> this.password = input}/>
                        </div>
                        <div className="form-group">
                            <input type="password" className="form-control" id="inputPassword" placeholder="New Password" ref={(input)=> this.newPass = input}/>
                        </div>
                        <div className="form-group">
                            <input type="password" className="form-control" id="inputPassword" placeholder="Confirm Password" ref={(input)=> this.newConfirm = input}/>
                        </div>
                        
                        <input type="button" className="btn btn-primary" value="Submit" onClick={this.tryChange}/>
                    </form>
                    {this.state.message ? <div className="alert alert-warning col-md-12">{this.state.message}</div>: null}
                </div>
            </div>
        );
    }
    tryChange(){
        let messageBody = {password: this.password.value, newPass: this.newPass.value}
        if(this.newPass.value === this.newConfirm.value){
            fetch(apiVariables.apiLink + "user/", {
                method: "PUT",
                credentials: apiVariables.credentials,
                headers: apiVariables.headers,
                body: JSON.stringify(messageBody)
            })
            .then((response) => this.setState({message: response.statusText}))
        }
        else{
            this.setState({message: "Passwords don't match"})
        }

    }
}
class AdminPanel extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            users: null,
            selected: null
        }
        this.getUsers = this.getUsers.bind(this);
        this.getDetails = this.getDetails.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
    }
    async getUsers(){
        return await fetch(apiVariables.apiLink + "user/userList", {
            method: "GET",
            credentials: apiVariables.credentials,
            headers: apiVariables.headers
        }).then(res => res.json())
        .then(resJson => resJson);
    }
    async getDetails(username){
        return await fetch(apiVariables.apiLink + "user/details?username=" + encodeURIComponent(username), {
            method: "GET",
            credentials: apiVariables.credentials,
            headers: apiVariables.headers
        }).then(res => res.json())
        .then(resJson => resJson);
    }
    async componentWillMount(){
        let users = await this.getUsers();
        users = users.Document.Users
        users.sort()
        this.setState({users: users})
    }
    async handleSelect(e){
        this.setState({selected: null})
        if(e.target.value){
            this.setState({selected: await this.getDetails(e.target.value)})
        }
        
    }
    render(){
        return (
            <div style={{marginTop: 50}}>
                {this.state.users ?
                    <div className="col-md-12">
                        <div className="col-md-2 col-xs-12"></div>
                        <div className="col-md-8 col-xs-12">
                            <div className="col-md-12 col-xs-12" style={{paddingBottom: "30px", marginBottom: "10px"}}>
                                <select className="form-control" onChange={this.handleSelect}>
                                    <option value={null}>--Users--</option>
                                    { this.state.users.map((user, index) => 
                                        <option key={index} value={user.username}>{user.username}</option>
                                    )}
                                </select>
                            </div>
                                {this.state.selected ? 
                                <div className="col-md-12 col-xs-12" style={{marginBottom: "30px", padding: "10px", border: "1px solid #E7E7E7"}}>
                                    <AdminForm user={this.state.selected} organizations={this.props.organizations}/> 
                                </div>
                                : null}
                            <div className="col-md-2 col-xs-2">
                                {!this.state.selected ? <button type="button" className="btn btn-success" onClick={() => {this.setState({selected: {username: ""}})}}><span className="glyphicon glyphicon-plus"/></button> : null}
                            </div>
                        </div>
                    </div> 
                : null}
            </div>
            
                )
    }
}

class AdminForm extends React.Component{
    constructor(props){
        super(props)
        this.generateSelect = this.generateSelect.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleOrg = this.handleOrg.bind(this);
        this.handleDelete  = this.handleDelete.bind(this);
        this.organizations = null
        this.selectedOrgs = []
        this.originalOrgs = []
        if(this.props.user.username){
            for(let i in this.props.user.organizations){
                this.selectedOrgs.push(this.props.user.organizations[i].organization)
            }
            this.originalOrgs = this.selectedOrgs
            this.state = {
                newUser: false,
                authLevel: this.props.user.authLevel
            }
        }
        else{
            this.state={
                newUser: true,
                authLevel: this.props.user.authLevel
            }
        }
    }
    handleSubmit(){
        let user = {
            organizations: this.selectedOrgs
                 .filter(x => !this.originalOrgs.includes(x))
                 .concat(this.originalOrgs.filter(x => !this.selectedOrgs.includes(x)))
        }
        if(this.pass.value){
            if(this.pass.value === this.confirmPass.value){
                user.password = this.pass.value
            }
            else{
                alert("Passwords don't match");
                return;
            }
        }
        if(this.authLevel.value !== this.props.user.authLevel){
            user.authLevel = this.authLevel.value
        }
        if(this.apiKey.value !== this.props.user.apiKey){
            user.apiKey = this.apiKey.value
        }
        if(this.state.newUser){
            user.username = this.username.value;
            fetch(apiVariables.apiLink + 'user', {
                method: 'POST',
                credentials: apiVariables.credentials,
                headers: apiVariables.headers,
                body: JSON.stringify(user)
            }).then((res) => {
                if(res.status === 200){
                    window.location.reload();
                }
                else{
                    alert(res.message)
                }
            })
        }
        else{
            user.username = this.props.user.username
            fetch(apiVariables.apiLink + 'user/', {
                method: 'PUT',
                credentials: apiVariables.credentials,
                headers: apiVariables.headers,
                body: JSON.stringify(user)
            }).then((res) => {
                if(res.status === 200){
                    window.location.reload();
                }
                else{
                    alert(res.message)
                }
            })
        }
    }
    handleDelete(){
        if(window.confirm("Are you sure you want to delete " + this.props.user.username)){
            fetch(apiVariables.apiLink + "user?username=" + encodeURIComponent(this.props.user.username), {
                method: "DELETE",
                credentials: apiVariables.credentials,
                headers: apiVariables.headers
            }).then((res) => {
                if(res.status === 200){
                    window.location.reload();
                }
                else{
                    alert(res.message)
                }
            })
        }
        
    }
    handleOrg(e){
        let options = e.target.options;
        var organizations = [];
        for(let i in options){
            if(options[i].selected){
                organizations.push(options[i].value);
            }
        }
        this.selectedOrgs = organizations
    }
    render(){
        return (
                <form>
                    {this.state.newUser ? 
                        <div className="col-md-12" style={{marginBottom: "30px"}}>
                            <div className ="form-group row">
                                <label htmlFor ="username" className ="col-sm-2 col-form-label">Username:</label>
                                <div className ="col-sm-10">
                                <input type="text" className ="form-control" id="username" defaultValue="" ref={(input) => this.username = input} placeholder="Username"/>
                            </div>
                        </div>
                  </div>  
                    : null}
                    <div className="col-md-12" style={{marginBottom: "30px"}}>
                        <div className ="form-group row">
                            <label htmlFor ="apiKey" className ="col-sm-2 col-form-label">Api Key:</label>
                            <div className ="col-sm-10">
                            <input type="text" className ="form-control" id="apiKey" placeholder="Api Key" defaultValue={this.props.user.apiKey} ref={(input) => this.apiKey = input} />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12" style={{marginBottom: "10px"}}>
                        <div className ="form-group row">
                            <label htmlFor ="pass" className ="col-sm-2 col-form-label">{!this.state.newUser ? "Change " : null}Password:</label>
                            <div className ="col-sm-10">
                            <input type="password" className ="form-control" id="pass" placeholder="Password" ref={(input) => this.pass = input} />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12" style={{marginBottom: "30px"}}>
                        <div className ="form-group row">
                            <label htmlFor ="confirmPass" className ="col-sm-2 col-form-label">Confirm Password:</label>
                            <div className ="col-sm-10">
                            <input type="password" className ="form-control" id="confirmPass" placeholder="Confirm Password" ref={(input) => this.confirmPass = input} />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12" style={{marginBottom: "30px"}}>
                    <div className ="form-group row">
                            <label htmlFor ="authLevel" className ="col-sm-2 col-form-label">Authorization level:</label>
                            <div className ="col-sm-10">
                            <select className="form-control" id="authLevel" ref={(input) => this.authLevel = input} onChange={(e) => {this.setState({authLevel: e.target.value})}}defaultValue={this.props.user.authLevel}>
                                <option value="admin">Admin</option>
                                <option value="user">User</option>   
                            </select>
                        </div>
                        </div>
                       
                    </div>
                    <div className="col-md-12" style={{marginBottom: "20px"}}>
                        {this.state.authLevel !== 'admin' ? 
                            <select multiple className="form-control" defaultValue={this.selectedOrgs} onChange={this.handleOrg}>
                                {this.generateSelect()}
                            </select> : null}
                    </div>
                    <input type="button" className="btn btn-success" value="Submit" onClick={this.handleSubmit}/>
                    {!this.state.newUser ? <input style={{marginLeft: "30px"}} type="button" className="btn btn-danger" value="Delete" onClick={this.handleDelete}/> : null}
                </form>
        )
    }
    generateSelect(){
        let returner = [];
        for(let i in this.props.organizations){
            returner.push(<option key={i} value={this.props.organizations[i].organization}>{this.props.organizations[i].organization}</option>)
        }
        return returner
    }
}


// WEBPACK FOOTER //
// ./src/pages/profile.js